import React, { useContext, useEffect, useState } from 'react'
import { Link } from 'react-router-dom';
import { Spinner } from '../../commonLib/Spinner';
import { loadingMiniContext } from '../../commonLib/lodingMiniContext';
import AppToaster from '../../commonLib/AppToaster';
import { Container } from '../../base/Container';
import { Paging } from '../../commonLib/Paging';
import { GetEProductionUnitOwnershipName } from '../../enumCollections/EProductionUnitOwnership'
import { GetEBoolName } from '../../enumCollections/EBool';
import * as productionUnitCrud from '../../_crud/productionUnitCrud'
import { PAGING_PAGE_SIZE } from '../../config/GlobalSettings';
import 'moment-timezone';
import { EmptyData } from '../../commonLib/EmptyData';
import { MyAlert } from '../../commonLib/MyAlert';
import { GetEProductionCategoryTypeName } from '../../enumCollections/EProductionCategoryType';
import { dashboardContext } from '../Global/dashboardContext';
import { UserView } from '../Global/Elements/UserView';
import { ContactView } from '../Global/Elements/ContactView';
import { TextBoxTranslater } from '../../commonLib/TextBoxTranslater';

const initValues = {
    searchTerm: "",
    pageNo: 1,
    pageSize: PAGING_PAGE_SIZE
}

export function ManageProductionUnit() {
    const [isLoadingMini, setIsLoadingMini] = useContext(loadingMiniContext)
    const [search, setSearch] = useState(initValues)
    const [productionUnit, setProductionUnit] = useState([])
    const [LastPage, setLastPage] = useState(1)
    const [pagingData, setPagingData] = useState()
    const [dashboardData, setDashboardData] = useContext(dashboardContext)

    const OnPageChange = (e) => {
        const { value } = e.target
        setSearch({ ...search, pageNo: value });
        getData({ searchTerm: search.searchTerm, pageNo: value, pageSize: search.pageSize })
    }

    useEffect(() => {
        getData({ searchTerm: search.searchTerm, pageNo: 1, pageSize: search.pageSize })
    }, [])

    function onSearch() {
        getData({ searchTerm: search.searchTerm, pageNo: 1, pageSize: search.pageSize })
    }

    function getData(searchparam) {
        setIsLoadingMini(true);
        productionUnitCrud.GetAll(searchparam)
            .then(res => {
                if (res.data.data) {
                    if (res.data.result.succeeded) {
                        let hdata = res.data.data
                        let paging = res.data.paging
                        setPagingData(paging)
                        setLastPage(paging.pageCount)
                        setProductionUnit(hdata);
                        setIsLoadingMini(false)
                    }
                    else {
                        setLastPage(1)
                        setIsLoadingMini(false)
                        setProductionUnit([]);
                    }
                }
                else {
                    setLastPage(1)
                    setIsLoadingMini(false)
                    setProductionUnit([]);
                    AppToaster("Server Error /Invalid Try.", 'error')
                }
            })
            .catch(error => {
                setLastPage(1)
                setIsLoadingMini(false);
                AppToaster(error, 'error')
            })
    }

    function doRefresh(event) {
        setSearch({ ...search, pageNo: 1 })
        getData({ searchTerm: search.searchTerm, pageNo: 1, pageSize: search.pageSize })
        setTimeout(() => {
            event.target.complete();
        }, 1000);
    }

    function SearchChange(e) {
        const value = e.target.value
        setSearch({ ...search, searchTerm: value })
    }

    const DeleteItem = (id) => {
        setIsLoadingMini(true);
        productionUnitCrud.Remove(id)
            .then(res => {
                if (res.data.succeeded) {
                    setIsLoadingMini(false);
                    AppToaster('Deleted successfully.', 'success')
                    getData()
                }
                else {
                    setIsLoadingMini(false);
                    AppToaster('Using by someone, could not delete.', 'error')
                }

            }).catch(error => {
                setIsLoadingMini(false);
                AppToaster('Network error', 'error')
            })
    }

    return (
        <Container title="Production Unit" doRefresh={doRefresh}>
            <Link to="/productionunit/add" class="btn btn-sm btn-success">
                <i class="ace-icon glyphicon glyphicon-plus bigger-110"></i>
                New
            </Link>
            <Link to="/productionunit/category" style={{ marginLeft: "5px" }} class="btn btn-sm btn-primary">
                <i class="ace-icon glyphicon glyphicon-plus bigger-110"></i>
                Manage Category
            </Link>
            <Link to="/productionunit/configuration" style={{ marginLeft: "5px" }} class="btn btn-sm btn-warning">
                <i class="ace-icon glyphicon glyphicon-plus bigger-110"></i>
                Manage Configuration
            </Link>
            <div class="hr dotted"></div>
            <div class="form-horizontal" >
                <div className="row">
                    <div className="col-md-11">
                        <div class="form-group" style={{ marginLeft: "0", marginRight: "0" }}>
                            <span class="input-icon" style={{ width: "100%" }}>
                                <TextBoxTranslater style={{paddingLeft: "24px"}} value={search.searchTerm} onChange={(e) => setSearch({ ...search, searchTerm: e.target.value })} className="form-control" type="text" id="form-field-icon-1" placeholder="Search eg. id, phone etc" />
                                <i class="ace-icon fa fa-search blue"></i>
                            </span>
                        </div>
                    </div>
                    <div className="col-md-1">
                        <div class="form-group" style={{ marginLeft: "0", marginRight: "0" }}>
                            <button onClick={onSearch} to="/contact/add" class="btn btn-sm btn-info pull-right">
                                <i class="ace-icon fa fa-search bigger-110"></i>
                                Run
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <Paging
                pagingData={pagingData}
                LastPage={LastPage}
                CurrentPage={search.pageNo}
                OnPageChange={OnPageChange} >
                {isLoadingMini ?
                    <Spinner />
                    :
                    productionUnit && productionUnit.length > 0 ?
                        <div className="tables-scroll">
                            <table className="table table-hover table-bordered">
                                <thead>
                                    <tr>
                                        <th style={{ width: "43px" }}></th>
                                        <th>#Id</th>
                                        <th>Name</th>
                                        <th>Contact</th>
                                        <th>Category</th>
                                        <th>Configuration</th>
                                        <th>Type</th>
                                        <th>Is Multi Product</th>
                                        <th>Ownership</th>
                                        <th>Details</th>
                                        <th style={{ width: "43px" }}>By</th>
                                        <th style={{ width: "72px" }}></th>
                                    </tr>
                                </thead>

                                <tbody>
                                    {productionUnit.map((item, index) =>
                                        <tr key={item.id}>
                                            <td>
                                                <div class="btn-group">
                                                    <Link className="btn btn-xs btn-info" to={"/productionunit/dashboard/" + item.id} title="View dashboard" ><i class="ace-icon fa fa-tachometer"></i></Link>
                                                </div>
                                            </td>
                                            <td>{item.id}</td>
                                            <td>{item.productionUnitName}</td>
                                            <td>
                                                <Link to={"/contact/dashboard/" + item.contactId}>
                                                    <ContactView item={item.contact} uid={"C" + index} />
                                                </Link>
                                            </td>
                                            <td>{item.productionCategory.productionCatName}</td>
                                            <td>
                                                {item.productionConfiguration ?
                                                    <Link to={"/productionunit/configuration/dashboard/" + item.productionConfiguration.id}>
                                                        {item.productionConfiguration.name}
                                                    </Link>
                                                    :
                                                    "NA"
                                                }
                                            </td>
                                            <td><span class={item.productionCategory.type == 1 ? "label label-sm label-info" : "label label-sm label-warning"}>{GetEProductionCategoryTypeName(item.productionCategory.type)}</span></td>
                                            <td><span class={item.isMultiProduct == 1 ? "label label-sm label-success" : "label label-sm label-danger"}>{GetEBoolName(item.isMultiProduct)}</span></td>
                                            <td><span class={item.ownerShip == 1 ? "label label-sm label-info" : "label label-sm label-warning"}>{GetEProductionUnitOwnershipName(item.ownerShip)}</span></td>
                                            <td><div style={{ width: "150px" }}>{item.details}</div></td>
                                            <td>
                                                <UserView item={item.createdByUser} uid={"D" + index} createdOn={item.createdOn} />
                                            </td>
                                            <td>
                                                <div style={{ width: "73px" }}>
                                                    <div class="btn-group">
                                                        <Link to={"/productionunit/edit/" + item.id} onClick={() => setDashboardData({ ...dashboardData, productiondata: item })} class="btn btn-xs btn-success">
                                                            <i class="ace-icon fa fa-pencil bigger-120"></i>
                                                        </Link>
                                                        <MyAlert confirmBtnText="Yes, delete it!" title="Delete" onConfirm={DeleteItem} param={item.id}>
                                                            <i class="ace-icon fa fa-trash-o bigger-120"></i>
                                                        </MyAlert>
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                        :
                        <EmptyData>
                            No records found.
                            <br />
                            <br />
                        </EmptyData>
                }
            </Paging>
        </Container >
    )
}